var map = {
	"./default-gift-card-labels.js": 598,
	"./es-mx/default-gift-card-labels.js": 599,
	"./es/default-gift-card-labels.js": 600,
	"./fr/default-gift-card-labels.js": 601,
	"./pt/default-gift-card-labels.js": 602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 597;